import { getIn } from 'fun-util';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import PopupConstants, { SelfServeBuilderPopupTypes } from '../PopupConstants';

export const DEFAULT_STATE = false;

const isEditingPopup = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SelfServeBuilderEnum.SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS:
      // isEditingPopup is boolean depending on existence of activePopup
      if (getIn(action, 'data', 'custom_template', 'published_at')) {
        return false;
      }
      return !!(getIn(action, 'data', 'custom_template', 'field_outline', 'activePopup'));
    case PopupConstants.ACTIVE_POPUP_SET:
    case PopupConstants.CHANGE_POPUP:
    case PopupConstants.CREATE_POPUP:
    case PopupConstants.EDIT_POPUP_START:
      return true;
    case PopupConstants.CLEAR_ACTIVE_POPUP:
    case PopupConstants.DELETE_POPUP:
    case PopupConstants.EDIT_POPUP_END:
      return false;
    case PopupConstants.MOVE_POPUP:
      return getIn(action, 'state', 'popups', action.id, 'type') !== SelfServeBuilderPopupTypes.SIGNATURE;
    default:
      return state;
  }
};

export default isEditingPopup;



// WEBPACK FOOTER //
// ./src-react/Popups/PopupsReducer/isEditingPopup.jsx